export default __webpack_public_path__ + "37a9c6429c2eaef91fb9e44d2a441a02.svg";